import React, { useEffect } from "react";
import Jumpnav from "./organisms/jumpnav";
import PageHeader from "./organisms/page-header";
import PageFooter from "./organisms/page-footer";
import ControlBar from "./organisms/control-bar";
import { useStore } from "@nanostores/react";
import { $headless } from "../appStore";
import { $router } from "./router";

interface Props {
  children: React.ReactNode;
}

const Page = ({ children }: Props) => {
  const page = useStore($router);
  const headless = useStore($headless);

  // Scroll only on path changes: query changes (e.g. opening a station dialog) keep the position.
  const path = page?.path;
  useEffect(() => {
    if (!path?.split("/").includes("bulletin")) {
      if (!$router.get()?.hash) {
        window.scrollTo(0, 0);
      }
    }
  }, [path]);

  const dev = import.meta.env.APP_REGION === "DEV" && (
    <ControlBar
      style="yellow"
      message={
        <>
          This is a development version –{" "}
          <strong>no real data is shown!</strong>
        </>
      }
    />
  );

  if (headless && config.headlessLogo?.length) {
    return (
      <>
        <div id="page-header" className="page-header">
          <div className="page-header-logo">
            {config.headlessLogo.map((logo, i) => (
              <a href="/" key={i}>
                <img src={logo} style={{ margin: 0 }} />
              </a>
            ))}
          </div>
        </div>
        <main id="page-main" className="page-main">
          {dev}
          {children}
        </main>
      </>
    );
  } else if (headless) {
    return (
      <>
        {dev}
        {children}
      </>
    );
  }

  return (
    <>
      <div className="page-loading-screen" />
      <Jumpnav />
      <PageHeader />
      <main id="page-main" className="page-main">
        {dev}
        {children}
      </main>
      <PageFooter />
      <div
        id="tooltip-container"
        className="tooltip-container"
        style={{ display: "none" }}
      >
        <div className="tooltip-inner">
          <div className="tooltip-content"></div>
        </div>
      </div>
    </>
  );
};

export default Page;
